'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactRouter = require('react-router');

var _constants = require('redux/constants');

require('./UserProfileMenu.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    UserProfileMenuView: {
        displayName: 'UserProfileMenuView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/UserProfile/UserProfileMenu/default/UserProfileMenuView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var UserProfileMenuView = _wrapComponent('UserProfileMenuView')((_dec = (0, _reactRedux.connect)(null, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(UserProfileMenuView, _Component);

    function UserProfileMenuView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, UserProfileMenuView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UserProfileMenuView.__proto__ || (0, _getPrototypeOf2.default)(UserProfileMenuView)).call.apply(_ref, [this].concat(args))), _this), _this.handleRedirect = function (e) {
            var pushState = _this.props.pushState;


            pushState('/personal/' + e.target.value);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    /**
     * Редирект от выбора селекта
     */


    (0, _createClass3.default)(UserProfileMenuView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                active = _props.active,
                user = _props.user,
                lang = _props.lang;


            var resultFull = void 0,
                resultShort = void 0,
                username = void 0;

            var activePage = {
                activeProfile: false,
                activeOrder: false,
                activeAddresses: false,
                activeBasket: false,
                activeFavor: false,
                activeOperations: false
            };
            var activeSelect = 'profile';

            // TODO LANG проверить, как будет работать при языке, отличном от русского
            switch (active) {
                case 'Профиль':
                    activePage.activeProfile = true;
                    activeSelect = 'profile';
                    break;
                case 'Заказы':
                    activePage.activeOrder = true;
                    activeSelect = 'order-list';
                    break;
                case 'Адреса':
                    activePage.activeAddresses = true;
                    activeSelect = 'addresses';
                    break;
                case 'Выписка по счёту':
                    activePage.activeOperations = true;
                    activeSelect = 'operations';
                    break;
                case 'Избранное':
                    activePage.activeFavor = true;
                    activeSelect = 'wishlist';
                    break;
                case 'basket':
                    activePage.activeBasket = true;
                    activeSelect = 'basket';
                    break;
            }

            resultFull = _react3.default.createElement(
                'div',
                { className: 'hidden-xs' },
                _react3.default.createElement(
                    'ul',
                    { className: 'nav nav-pills nav-stacked nav-pills-stacked-example' },
                    _react3.default.createElement(
                        'li',
                        { role: 'presentation', className: activePage.activeProfile ? ' active ' : '' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/personal/profile' },
                            lang['store.user_profile_menu.profile']
                        )
                    ),
                    _react3.default.createElement(
                        'li',
                        { role: 'presentation', className: activePage.activeOrder ? ' active ' : '' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/personal/order-list?limit=' + _constants.Personal.OrderNumericConstants.ORDERS_PAGE_LIMIT + '&page=1' },
                            lang['store.user_profile_menu.orders']
                        )
                    ),
                    _react3.default.createElement(
                        'li',
                        { role: 'presentation', className: activePage.activeAddresses ? ' active ' : '' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/personal/addresses' },
                            lang['store.user_profile_menu.addresses']
                        )
                    ),
                    _react3.default.createElement(
                        'li',
                        { role: 'presentation', className: activePage.activeOperations ? ' active ' : '' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/personal/operations' },
                            lang['store.user_profile_menu.operations']
                        )
                    ),
                    _react3.default.createElement(
                        'li',
                        { role: 'presentation', className: activePage.activeFavor ? ' active ' : '' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/personal/wishlist' },
                            lang['store.user_profile_menu.wish_list']
                        )
                    ),
                    _react3.default.createElement(
                        'li',
                        { role: 'presentation', className: activePage.activeBasket ? ' active ' : '' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/personal/basket' },
                            lang['store.user_profile_menu.cart']
                        )
                    )
                )
            );

            resultShort = _react3.default.createElement(
                'div',
                { className: 'short-list' },
                _react3.default.createElement(
                    'select',
                    { className: 'form-control', onChange: this.handleRedirect, value: activeSelect },
                    _react3.default.createElement(
                        'option',
                        { value: 'profile' },
                        lang['store.user_profile_menu.profile']
                    ),
                    _react3.default.createElement(
                        'option',
                        { value: 'order-list' },
                        lang['store.user_profile_menu.orders']
                    ),
                    _react3.default.createElement(
                        'option',
                        { value: 'operations' },
                        lang['store.user_profile_menu.operations']
                    ),
                    _react3.default.createElement(
                        'option',
                        { value: 'wishlist' },
                        lang['store.user_profile_menu.wish_list']
                    ),
                    _react3.default.createElement(
                        'option',
                        { value: 'basket' },
                        lang['store.user_profile_menu.cart']
                    )
                )
            );

            if (user && user.hasOwnProperty('name') && (user.hasOwnProperty('email') || user.hasOwnProperty('phone'))) {
                var name = user.name,
                    email = user.email,
                    phone = user.phone;


                username = _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(
                        'p',
                        { className: 'name' },
                        name
                    ),
                    _react3.default.createElement(
                        'p',
                        { className: 'email' },
                        email
                    ),
                    _react3.default.createElement(
                        'p',
                        { className: 'email' },
                        phone
                    )
                );
            }

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'username' },
                    username
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'menu text-center' },
                    resultFull,
                    resultShort
                )
            );
        }
    }]);
    return UserProfileMenuView;
}(_react2.Component), _class2.propTypes = {
    pushState: _react2.PropTypes.func.isRequired,
    active: _react2.PropTypes.string.isRequired,
    user: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _temp2)) || _class));

exports.default = UserProfileMenuView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/UserProfileMenu/default/UserProfileMenuView.jsx
// module id = 1784
// module chunks = 0